import type { FootballPlayerRelationshipResponse } from '@ballpeek/api/client'

import { authApiClient } from '~/lib/api-client'

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let message = `Request failed with status ${response.status}`
    try {
      const body = await response.json() as {
        error?: { issues?: Array<{ message?: string }>, message?: string }
        message?: string
      }
      message = body.message ?? body.error?.message ?? body.error?.issues?.[0]?.message ?? message
    }
    catch {
      // Preserve the status fallback for non-JSON responses.
    }
    throw new Error(message)
  }
  return response.json() as Promise<T>
}

export async function getFootballPlayerRelationships(apiSportsPlayerId: number, at?: string) {
  const response = await authApiClient.api.football.players[':apiSportsPlayerId'].relationships.$get({
    param: { apiSportsPlayerId: String(apiSportsPlayerId) },
    query: at ? { at } : {},
    header: { Authorization: '' },
  })
  return parseJson<FootballPlayerRelationshipResponse>(response)
}
